import { useContext } from "react";
import { SxProps, Theme, useTheme } from "@mui/material";
import { BodycamContext } from "../../context/BodycamContext";

// Sidebar width constants (must match MainComponent/SideBar)
const drawerWidth = 240;
const drawerWidthXXL = 300;
const drawerWidthUHD = 360;
const closedDrawerWidth = 72;
const closedDrawerWidthXXL = 125;
const closedDrawerWidthUHD = 150;

/**
 * Returns sxOverrides for SnackBarMessage that account for sidebar width
 * and position the snackbar at the given vertical offset (default 45%).
 */
export const useSnackbarPosition = (top = "45%"): SxProps<Theme> => {
  const theme = useTheme();
  const { openSidebar } = useContext(BodycamContext);
  const [open] = openSidebar;

  return {
    top: `${top} !important`,
    [theme.breakpoints.up("uhd")]: {
      left: `calc(50% + ${(open ? drawerWidthUHD : closedDrawerWidthUHD) / 2}px) !important`,
    },
    [theme.breakpoints.between("xxl", "uhd")]: {
      left: `calc(50% + ${(open ? drawerWidthXXL : closedDrawerWidthXXL) / 2}px) !important`,
    },
    [theme.breakpoints.between("lg", "xxl")]: {
      left: `calc(50% + ${(open ? drawerWidth : closedDrawerWidth) / 2}px) !important`,
    },
    [theme.breakpoints.down("lg")]: {
      left: "50% !important",
    },
  };
};
